import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import ButtonSelector from '../ButtonSelector'

import { decode } from '@aytm/app/insights/dashboard/lib/sanitize'

import './CurrentSplitSelector.scss'

const CLASS = 'insights-portal-current-split-selector'

const CurrentSplitSelector = props => {
  const className = props.className || CLASS

  const splits = useMemo(() => props.splits || [], [props.splits])

  const currentSplit = props.currentSplit || null
  const splitText = useMemo(() => {
    const splitOption = currentSplit ? splits.find(v => currentSplit === v.id) : null
    return splitOption ? `Split by: ${splitOption.title}` : 'Split by: None'
  }, [currentSplit, splits])

  const splitOptions = useMemo(() => {
    const result = splits.map(v => {
      return { code: v.id, name: decode(v.title) }
    })
    result.unshift({ code: null, name: 'None' })
    return result
  }, [splits])

  const onCurrentSplitChange = event => {
    if (props.onCurrentSplitChange && event.value.code !== currentSplit)
      props.onCurrentSplitChange({ currentSplit: event.value.code })
  }

  return (
    <ButtonSelector
      className={className}
      options={splitOptions}
      label={decode(splitText)}
      onChange={onCurrentSplitChange}
    />
  )
}

CurrentSplitSelector.propTypes = {
  className: PropTypes.string,
  splits: PropTypes.array,
  currentSplit: PropTypes.string,
  onCurrentSplitChange: PropTypes.func
}

CurrentSplitSelector.defaultProps = {
  splits: []
}

export default CurrentSplitSelector
